import { useDispatch } from '@redux';
import { replaceSku } from '@redux/orders/actions';
import { Form, Input, Modal } from 'antd';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SelectCustom from './VNCitySelector/SelectCustom';
import { omit } from 'lodash';

interface IReplaceSKUModalProps {
  visible: boolean;
  onCancel: () => void;
  href?: string;
  id: string;
  currentOrder: any;
}

const ReplaceSKUModal = ({
  visible,
  onCancel,
  href,
  id,
  currentOrder,
}: IReplaceSKUModalProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    const itemIndex = currentOrder?.items?.findIndex(
      (item) => item.variantSku === values.oldVariantSku,
    );

    const quantity = currentOrder?.items[itemIndex]?.quantity;
    try {
      const res = await dispatch(
        replaceSku({
          data: {
            id,
            data: {
              ...omit(values, 'oldVariantSku'),
              variantSku: values?.variantSku.trim(),
              line: itemIndex,
              quantity: quantity,
            },
          },
        }),
      );
      setLoading(false);
      if (!res?.payload?.message) {
        onCancel();
        window.location.reload();
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      title={t('orderDetail.replaceSKU')}
      onCancel={onCancel}
      onOk={form.submit}
      okButtonProps={{ loading: loading }}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Trans
          i18nKey="orderDetail.replaceSKUDesc"
          components={{
            a: (
              <a
                className="underline text-[--primary]"
                href={href}
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
        <br />
        <br />
        <SelectCustom
          source="oldVariantSku"
          resourceData={currentOrder?.items || []}
          valueProp="variantSku"
          titleProp="variantSku"
          placeholder={t('input.variantSku.select.placeholder')}
        />
        <Form.Item
          name="variantSku"
          rules={[
            { required: true, message: t('input.variantSku.input.require') },
          ]}
        >
          <Input placeholder={t('input.variantSku.input.placeholder')} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReplaceSKUModal;
